<template>
	<v-row>
		<v-col :cols="6">
			<v-row v-if="!showDateSelection" class="mt-2 pl-2 pr-2" align="center" justify="center">
				<calendar-date-icon
					v-for="day in bookingDates"
					:key="getDayDate(day)"
					color="green"
					:card_color="''"
					:card_text_color="''"
					:date="getDayDate(day)"
					:start_time="getDayStart(day)"
					:end_time="getDayEnd(day)"
					small
					class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
				>
				</calendar-date-icon>
			</v-row>
			<v-row v-if="showDateSelection">
				<v-col class="date-selection-wrapper">
					<v-checkbox v-model="AllDates" label="Select All Dates" @click="SelectAllDates()"></v-checkbox>
				</v-col>
			</v-row>
			<div v-if="showDateSelection" :key="keyboi" class="date-selection-wrapper">
				<v-row class="pt-2" no-gutters align="center" justify="center">
					<v-card
						v-for="date in dateSelection"
						:key="date.date"
						outlined
						elevation="1"
						class="ml-1 mr-1 mt-2 mb-2 pl-1 pr-1"
						style="border-radius: 8px; !important"
						@click="onClickDateIcon(date)"
					>
						<v-row no-gutters>
							<v-col cols="12">
								<calendar-date-icon
									:color="getDayColor(date)"
									:date="date.date"
									:start_time="getLocumDayTime(date.date, 'start_time')"
									:end_time="getLocumDayTime(date.date, 'end_time')"
									small
									class="ml-1 mr-1 mt-2 mb-0 justify-center text-center"
									@click="onClickDateIcon(date)"
								>
								</calendar-date-icon>
							</v-col>
						</v-row>
						<v-row v-if="isDayAvailable(date)" no-gutters align="center" justify="center" class="pl-0 pt-1 pb-0 mb-1">
							<v-icon v-if="!(date.date in selectedDates && selectedDates[date.date])" color="primary" class="pa-0 ma-0" @click="onClickDateIcon(date)"
								>radio_button_unchecked</v-icon
							>
							<v-icon v-else color="#63C367" class="pa-0 ma-0" @click="onClickDateIcon(date)">radio_button_checked</v-icon>
						</v-row>
						<v-row v-else no-gutters align="center" justify="center" class="pl-0 pt-1 pb-0 mb-1"><v-icon color="grey">not_interested</v-icon></v-row>
					</v-card>
				</v-row>
			</div>
		</v-col>
		<v-col :cols="6" align="left" justify="left">
			<div v-if="booking.profession" class="mt-2">
				<small>
					<strong>Profession:</strong>
					{{ booking.profession }}
				</small>
			</div>
			<!-- TODO - May be re-added later -->
			<!-- <div>
				<small>
					<strong>Rates:</strong>
					{{ formattedRates }}
				</small>
			</div>
			<div>
				<small>
					<strong>Experience:</strong>
					{{ formattedExperience }}
				</small>
			</div> -->
			<div v-if="booking.start_time && showTimes">
				<small>
					<strong>Start Time:</strong>
					{{ booking.start_time }}
				</small>
			</div>
			<div v-if="booking.end_time && showTimes">
				<small>
					<strong>End Time:</strong>
					{{ booking.end_time }}
				</small>
			</div>

			<div v-if="formattedSkills">
				<small>
					<strong>Requirements:</strong>
					{{ formattedSkills }}
				</small>
			</div>

			<div v-if="formattedRates && !isLocumViewingPractice">
				<small>
					<strong>Budget:</strong>
					{{ formattedRates }}
				</small>
			</div>

			<div v-if="booking.lunch">
				<small>
					<strong>Lunch:</strong>
					{{ lunchDetails }}
				</small>
			</div>

			<div v-if="booking.notes">
				<div>
					<small>
						<strong>Notes:</strong>
					</small>
				</div>

				<div>
					<small>
						{{ booking.notes }}
					</small>
				</div>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import store from '@/store';
import moment from 'moment';
import { bus } from '@/main';
import { mapGetters } from 'vuex';

import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';

export default {
	name: 'BookingDetails',
	components: { CalendarDateIcon },
	props: {
		booking: {},
		showDateSelection: {
			default: false,
		},
	},
	data: () => ({
		selectedDates: {},
		keyboi: 0,
		AllDates: false,
		showTimes: true, // show times only if they all match the request dates
	}),
	computed: {
		...mapGetters(['getLocumViewingPractice']),

		lunchDetails() {
			if (!this.booking.lunch) {
				return '';
			}
			const { allowed, paid, period } = this.booking.lunch;

			if (!allowed) {
				return 'No Lunch Break';
			}

			const timePeriod = period === '0.5' ? '30 minutes' : '1 hour';

			return paid ? `Paid ${timePeriod} Lunch Break` : `Unpaid ${timePeriod} Lunch Break`;
		},
		formattedRates() {
			if (!this.booking.rates) {
				return '';
			}
			const [to, from] = this.booking.rates;
			return `R${to} - R${from}`;
		},
		dateSelection() {
			if (
				(this.viewSource !== undefined && ['viewUpcomingBooking', 'viewApplicationSent'].includes(this.viewSource)) ||
				['viewLocumApplication', 'viewUpcomingBooking'].includes(this.locumFromStore?.source)
			) {
				try {
					return this.booking.booking_dates_times.map(date => ({ already_booked: false, date, status: 'Possibly Available' }));
				} catch (e) {
					return this.booking.booking_dates.map(date => ({ already_booked: false, date, status: 'Possibly Available' }));
				}
			} else if (this.viewSource === 'viewOffersNearMe' || this.viewSource === 'viewBookingRequest') {
				const dates = this.booking.booking_dates.map(date => ({ already_booked: false, date, status: 'Possibly Available' }));
				if (!this.booking.request_dates) return dates;

				return dates.filter(date => this.booking.request_dates.some(requestDate => requestDate.date === date.date));
			} else return this.booking.mapped_dates;
		},
		bookingDates() {
			if (
				(this.viewSource !== undefined && ['viewUpcomingBooking', 'viewApplicationSent'].includes(this.viewSource)) ||
				['viewLocumApplication', 'viewUpcomingBooking'].includes(this.locumFromStore?.source)
			) {
				const { end_time, start_time } = this.booking;
				return (
					this.booking.booking_dates_times ??
					this.booking.booking_dates.map(date => {
						const isoStart = moment(`${date} ${start_time}`).format();
						let isoEnd = moment(`${date} ${end_time}`).format();

						return { date, end_time: isoEnd, start_time: isoStart };
					})
				);
			} else if (this.booking.request_dates && this.booking.request_dates.length > 0) {
				return this.booking.request_dates;
			}
			const { end_time, start_time } = this.booking;

			const requestDatesObject = this.booking.booking_dates.map(date => {
				const isoStart = moment(`${date} ${start_time}`).format();
				let isoEnd = moment(`${date} ${end_time}`).format();

				return { date, end_time: isoEnd, start_time: isoStart };
			});
			return requestDatesObject;
		},
		viewSource() {
			return this.getLocumViewingPractice?.source;
		},
		locumFromStore() {
			if (store.getters.getPracticeViewingLocum?.length > 0) return store.getters.getPracticeViewingLocum[0];
			else return null;
		},
		isLocumViewingPractice() {
			return !!this.getLocumViewingPractice;
		},
		formattedSkills() {
			const { skills } = this.booking;
			if (skills && skills.length) {
				return skills.map(({ name }) => name).join(', ');
			}
			return '';
		},
		// formattedExperience() {
		// 	return `${this.booking.experience} year${this.booking.experience === 1 ? '' : 's'} +`;
		// },
	},
	mounted() {
		if (this.booking.request_dates) {
			for (let index = 0; index < this.booking.request_dates.length; index++) {
				if (
					moment(this.booking.request_dates[index].start_time).format('HH:mm') !== this.booking.start_time ||
					moment(this.booking.request_dates[index].end_time).format('HH:mm') !== this.booking.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
			if (this.booking?.booking_dates_times !== [] && this.booking?.booking_dates_times !== undefined) {
				for (let index = 0; index < this.booking?.booking_dates_times.length; index++) {
					if (
						moment(this.booking?.booking_dates_times[index].start_time).format('HH:mm') !== this.booking.start_time ||
						moment(this.booking?.booking_dates_times[index].end_time).format('HH:mm') !== this.booking.end_time
					) {
						this.showTimes = false;
						break;
					}
				}
			}
		}
	},
	methods: {
		onClickDateIcon(dateInfo) {
			const { date } = dateInfo;
			if (!this.isDayAvailable(dateInfo)) {
				return;
			}
			let value = date in this.selectedDates ? !this.selectedDates[date] : true;
			this.selectedDates[date] = value;
			this.keyboi++;
			bus.$emit('update-selected-dates', this.selectedDates);
		},
		dateFormatted(date) {
			return moment(date).format('MMM DD YYYY');
		},

		isDayAvailable({ status }) {
			return !['Requested', 'Unavailable'].includes(status);
		},

		getDayDate(day) {
			if (typeof day === 'string') {
				return day;
			}
			if (typeof day === 'object' && day.date) {
				return day.date;
			}
			return '';
		},

		getDayStart(day) {
			if (typeof day === 'object' && day.start_time) {
				return moment(day.start_time).format('HH:mm');
			}
			return '';
		},
		getLocumDayTime(day, time) {
			if (this.booking.request_dates) {
				const request_date = this.booking.request_dates.find(({ date }) => date === day);
				if (!request_date) return '';

				return moment(request_date[time]).format('HH:mm');
			}

			return '';
		},

		getDayEnd(day) {
			if (typeof day === 'object' && day.end_time) {
				return moment(day.end_time).format('HH:mm');
			}
			return '';
		},

		getDayColor({ status }) {
			switch (status) {
				case 'Possibly Available':
					return 'primary';
				case 'Available':
					return '#63C367';
				case 'Unavailable':
					return '#9B9B9B';
			}
		},

		async SelectAllDates() {
			if (this.AllDates) {
				this.selectedDates = [];
				this.dateSelection.forEach(date => {
					this.onClickDateIcon(date);
				});
			} else if (!this.AllDates) {
				this.selectedDates = [];
			}
		},
	},
};
</script>

<style scoped>
.date-selection-wrapper {
	max-height: 350px;
	overflow-y: auto;
}
</style>
